var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMotorboats = function SvgMotorboats(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3 395.7C60.34 395.7 60.34 431.7 96.3801 431.7C132.42 431.7 132.42 395.7 168.46 395.7C204.5 395.7 204.5 431.7 240.54 431.7C276.58 431.7 276.58 395.7 312.63 395.7C348.68 395.7 348.67 431.7 384.72 431.7C420.77 431.7 420.76 395.7 456.81 395.7",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.01 338.08C70.38 326.74 78.76 315.4 87.13 304.06C140.13 293.26 189.07 286.54 232.89 282.44C258.85 280.01 289.18 277.25 328.53 277.14C371.02 277.02 420.59 279.99 475.6 289.2C463.59 302.37 446.62 318.45 423.94 333.53C399.4 349.84 376.26 359.62 358.54 365.59",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M384.63 278.79C359.46 264.96 311.2 235.32 256.42 228.26C192.53 220.03 140.8 231.7 111.83 240.55C126.07 244.65 140.3 248.75 154.54 252.86L124.99 297.28",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M439.2 322.61C439.2 322.61 405.73 312.3 332.43 321.53",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMotorboats);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/icons/motorboats.svg";